import { getSonarObjectTypeSourceLabel } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { PeriscopeLink, PeriscopeSource } from '@ui/icons';
export const PeriscopeSourceLabel = ({ sonarObjectType, url }) => {
    const sourceLabel = getSonarObjectTypeSourceLabel(sonarObjectType);
    return (React.createElement("div", { className: 'source-label' },
        React.createElement(PeriscopeSource, { iconColor: 'rgba(255, 255, 255, 0.85)', sonarObjectType: sonarObjectType }),
        sourceLabel,
        React.createElement(PeriscopeLink, { iconColor: 'rgba(255, 255, 255, 0.85)', sonarObjectType: sonarObjectType, url: url })));
};
